module.exports = __webpack_public_path__ + "img/bg-header.f70d563d.png";